import { ChangeDetectorRef, Component, Input } from '@angular/core'
import { AvatarService } from './../avatar/avatar.service'
import { AvatarStyle } from './../avatar/avatar-data'

@Component({
  standalone: false,
  selector: 'se-org-avatar',
  host: {'class': 'se-org-avatar'},
  templateUrl: './org-avatar.component.html',
})
export class SeOrgAvatarComponent {

  @Input('se-data-size') size: string
  @Input('se-data-border') border: boolean = false
  @Input('se-data-img-url') imgUrl: string
  @Input('se-data-identity') identity: string

  public componentClass: string = ''
  public componentStyle: AvatarStyle
  public hasImage: boolean = false
  public initials: string

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private avatarService: AvatarService) {
    // noop
  }

  ngOnChanges(): void {
    this.init()
  }

  public async init(): Promise<void> {

    const data = await this.avatarService.getData(this.size, this.border, this.imgUrl, true)
    this.componentClass = data.componentClass
    this.componentStyle = data.componentStyle
    this.hasImage = data.hasImage
    this.initials = this.avatarService.getInitials(this.identity, 1)
    this.changeDetectorRef.detectChanges()

  }

}